import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';

/**
 * TIN-23 CA-09: Modal para registrar la devolución de una requisición.
 * Requiere una observación obligatoria que se persiste en timeline.DEVUELTA.
 *
 * @param {boolean} show
 * @param {() => void} onHide
 * @param {(observacion: string) => Promise<void> | void} onConfirmar
 */
const DevolucionModal = ({ show, onHide, onConfirmar }) => {
  const [observacion, setObservacion] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleConfirmar = async () => {
    if (!observacion.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Observación obligatoria',
        text: 'Debe especificar la razón de la devolución para que el proveedor pueda corregir.',
      });
      return;
    }
    try {
      setEnviando(true);
      await onConfirmar(observacion.trim());
      setObservacion('');
      onHide();
    } catch (e) {
      Swal.fire({
        icon: 'error',
        title: 'Error al devolver',
        text: e?.response?.data?.message || e?.message || 'No se pudo registrar la devolución.',
      });
    } finally {
      setEnviando(false);
    }
  };

  const handleHide = () => {
    if (enviando) return;
    setObservacion('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} centered backdrop="static">
      <Modal.Header closeButton={!enviando}>
        <Modal.Title>Devolver requisición</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          La requisición pasará al estado <strong>Devolución</strong>. El proveedor ganador
          podrá ver tu observación y subir nuevos certificados desde su portal.
        </p>
        <Form.Group>
          <Form.Label>Observación (obligatoria)</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={observacion}
            onChange={(e) => setObservacion(e.target.value)}
            placeholder="Describe por qué se devuelve la entrega y qué debe corregir el proveedor..."
            disabled={enviando}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide} disabled={enviando}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleConfirmar} disabled={enviando}>
          {enviando ? 'Procesando...' : 'Devolver'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DevolucionModal;
